var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransfer = function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "none",
    viewBox: "0 0 41 41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD370",
    d: "M15.824 5.138c.504-.318.955-.638 1.438-.9 2.349-1.278 4.815-1.423 7.361-.728a12.8 12.8 0 0 1 3.652 1.642c.155.101.324.232.402.39.213.439-.114.862-.631.872-.798.015-1.6-.006-2.391.075-1.968.201-3.81.779-5.41 1.99-.16.123-.308.263-.459.396-.03.027-.049.066-.089.122.36.356.705.715 1.068 1.054.224.208.338.442.252.739-.084.292-.328.394-.601.455q-2.631.584-5.26 1.17c-.8.179-1.598.36-2.398.533-.594.127-.95-.21-.822-.795.451-2.056.914-4.109 1.372-6.163.118-.53.228-1.06.357-1.587.148-.606.677-.759 1.125-.324.357.348.697.713 1.033 1.058zm9.707.01c-1.418-.726-3.834-1.006-5.545-.626-1.37.305-2.567.943-3.63 1.85-.414.351-.701.337-1.083-.047-.194-.195-.383-.393-.62-.637l-1.309 5.855 5.873-1.312c-.31-.296-.57-.529-.813-.78-.25-.26-.265-.55-.056-.84.1-.137.213-.266.331-.388 1.077-1.112 2.39-1.85 3.848-2.31.996-.316 2.027-.52 3.005-.765zM24.828 35.393c-.504.318-.955.638-1.438.9-2.348 1.278-4.815 1.423-7.36.728a12.8 12.8 0 0 1-3.652-1.642c-.155-.1-.325-.232-.402-.39-.213-.438.114-.862.63-.872.798-.015 1.6.007 2.392-.075 1.967-.2 3.809-.778 5.41-1.99.16-.123.307-.262.458-.396.03-.027.05-.066.09-.121-.36-.356-.705-.715-1.069-1.055-.223-.208-.337-.442-.252-.739.085-.291.329-.394.602-.454l5.26-1.172c.8-.177 1.597-.359 2.398-.531.593-.128.95.209.822.794-.451 2.056-.914 4.11-1.372 6.163-.118.53-.228 1.06-.357 1.587-.149.606-.678.76-1.125.324-.357-.347-.697-.713-1.033-1.058zm-9.706-.01c1.418.727 3.834 1.006 5.544.626 1.37-.304 2.567-.943 3.63-1.849.414-.352.702-.337 1.084.047.194.194.383.393.62.636l1.308-5.855-5.872 1.313c.309.295.57.528.812.78.25.26.266.55.056.839q-.152.205-.33.388c-1.077 1.112-2.39 1.85-3.849 2.31-.996.316-2.027.521-3.004.765"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.745,
    height: 16.489,
    x: 28.743,
    y: 9.172,
    stroke: "#FFD370",
    rx: 1.034
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.745,
    height: 16.489,
    x: 1.01,
    y: 14.775,
    stroke: "#FFD370",
    rx: 1.034
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.32.266h40v40h-40z"
  })))));
};
export default SvgTransfer;